var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _line, _line2, _g, _g2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke-linecap: round;\n      }\n\n      .cls-5, .cls-6 {\n        stroke: #f0f0f1;\n        stroke-miterlimit: 10;\n        stroke-width: .8px;\n      }\n\n      .cls-2 {\n        fill: #2b7705;\n      }\n\n      .cls-3 {\n        fill: #232020;\n      }\n\n      .cls-4 {\n        fill: #f0ebed;\n      }\n\n      .cls-6 {\n        fill: #192130;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.1,39.9c5.8,5.8,11.5,11.6,17.3,17.4,0,0,6.1,4.5,12.8-1.2.1,0,18.5-18.8,18.5-18.8,0,0,4.2-6.1-2.1-10.5,0,0,0,0,0,0-.7-.6-1.4-1.2-2.1-1.8-1.7-1.5-3.5-3-3.6-3.1-3.4-3-3.4-3.1-4-3.3-2.2-.8-4.4-.2-4.9,0-2,.7-3.3,2-3.8,2.5-3.1,3.2-6.3,6.4-9.6,9.7-3.3,3.2-6.5,6.4-9.7,9.5-.7.4-2.1,1-3.9,1.1-2.5,0-4.3-1.1-4.9-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.4,9.2l-3.3-3.2s-.8-1.1-1.5,0c0,0-3.1,3.2-3.1,3.2,0,0-.6.7,0,1.3,0,0,3.3,3.2,3.3,3.2,0,0,.7.5,1.2,0,0,0,3.5-3.5,3.5-3.5h.8s1.8,1.8,1.8,1.8v.9l-1.7,1.8s-.5.7,0,1.3c0,0,1.7,1.6,1.7,1.6,0,0,.5.4,1,0l1.7-1.8s.4-.5,0-1.1c0,0-1.8-1.7-1.8-1.7v-1s1.6-1.7,1.6-1.7c0,0,.5-.6,0-1.2,0,0-1.3-1.3-1.3-1.3,0,0-.8-.7-1.5,0l-1.5,1.5h-1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.7,
    y: 1.4,
    width: 3.8,
    height: 4,
    rx: 0.8,
    ry: 0.8,
    transform: "translate(11.2 34) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.7,
    y: 8.8,
    width: 2,
    height: 2.1,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(8.2 39.5) rotate(-45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.3,28.9c4.3-4.3,8.6-8.6,12.8-12.8l5.3,5.3-13.5,13.5c-.3.3-1.4,1.4-3.2,1.5-.6,0-1.8.1-2.7-.7-1.3-1.1-1.1-3-1-3.3.1-.9.5-1.6.7-1.9.5-.8,1.1-1.3,1.5-1.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.7,18.4l-21.6,21.6c-3.1,1.7-6.7,1.5-9.1-.6-2.5-2.2-2.4-5.6-2.4-5.8.1-2.3,1.3-3.9,1.7-4.4,3.1-3.1,6.2-6.1,9.3-9.2,3.1-3,6.1-5.9,9.2-8.8.3-.2,2.2-1.5,4.5-.9,1.8.5,2.8,1.8,3.1,2.1,1.7,2,3.5,3.9,5.2,5.9Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 26.6,
    y1: 15.4,
    x2: 7.3,
    y2: 34.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.7,
    y1: 18,
    x2: 10,
    y2: 37.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.3,3.1c0,0,.1-.2.2-.2s.2,0,.3,0,.2,0,.3,0c0,0,.2.2.2.3h-.3c0,0,0,0-.1-.1s-.1,0-.2,0-.1,0-.2,0c0,0,0,0-.1.1s0,.1,0,.2,0,.1,0,.2,0,0,.1.1c0,0,.1,0,.2,0s.1,0,.2,0,0,0,.1-.1h.3c0,.1-.1.2-.2.3,0,0-.2,0-.3,0s-.2,0-.3,0-.2-.1-.2-.2c0,0,0-.2,0-.3s0-.2,0-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.4,3v-.2h.4v1.2h-.2v-1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.1,3.7c.1,0,.2-.2.2-.2,0,0,.1-.1.2-.2,0,0,0-.1,0-.2s0,0,0-.1c0,0,0,0-.1,0s0,0-.1,0c0,0,0,0,0,.1h-.2c0-.1,0-.2.1-.3s.2,0,.3,0,.2,0,.3,0c0,0,0,.2,0,.3s0,.2,0,.2c0,0,0,.1-.2.2s-.1.1-.2.2h.5v.2h-.8v-.2h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.5,9.3c0-.2.2-.3.4-.4s.3-.1.5-.1.4,0,.6.2c.2.1.3.3.4.5h-.5c0,0-.1-.2-.2-.2,0,0-.2,0-.3,0s-.2,0-.3,0-.2.1-.2.2c0,0,0,.2,0,.3s0,.2,0,.3c0,.1.1.2.2.2,0,0,.2,0,.3,0s.2,0,.3,0,.1-.1.2-.2h.5c0,.2-.2.4-.4.5-.2.1-.4.2-.6.2s-.4,0-.5-.1c-.2,0-.3-.2-.4-.4,0-.2-.1-.3-.1-.5s0-.4.1-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.6,9s-.1,0-.2,0c-.1,0-.2,0-.3.2,0,.1,0,.3,0,.5,0,0,.1-.1.2-.2s.2,0,.3,0,.2,0,.3,0c0,0,.2.1.2.2s0,.2,0,.4,0,.3,0,.4c0,.1-.1.2-.2.2-.1,0-.2,0-.4,0s-.4,0-.5-.1c-.1,0-.2-.2-.2-.4,0-.2,0-.4,0-.6,0-.3,0-.6.2-.8.1-.2.3-.3.6-.3s.4,0,.5.2.2.2.2.4h-.4c0,0,0-.1,0-.2ZM40.1,9.8c0,0-.1.1-.1.3s0,.2,0,.3c0,0,.2,0,.3,0s.2,0,.2,0c0,0,0-.1,0-.3s0-.2,0-.3c0,0-.1,0-.3,0s-.2,0-.3,0Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.7,
    cy: 32.7,
    r: 1.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.6b317f86399bbafda95e6096a3044a4b.svg";
export { ForwardRef as ReactComponent };